import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ErrorService {
	getClientMessage(error: Error) {
		if (!navigator.onLine) return 'No Internet Connection';
		return error.message ? error.message : error.toString();
	}

	getClientStack(error: Error) {
		return error.stack;
	}

	getServerMessage(error: HttpErrorResponse) {
		return error.error?.messages;
	}

	getServerStack(error: HttpErrorResponse) {
		// handle stack trace
		return 'stack';
	}
}
